import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';
import { useQueryDownloader } from '@trinity/chat-components/containers/QueryDownloader/hooks';

type Params = {
  brandIdentifier: string;
  chatInstanceId: number;
  queryIdentifier: string;
};

export const useDownloadHcpResults = (params: Params) => {

  const apiClient = useChatApiClient();

  return useQueryDownloader({
    queryKey: [
      `brand-insights:query:download-hcp-results`,
      params.chatInstanceId,
      params.queryIdentifier,
      params.brandIdentifier,
    ],
    queryFn: ({ queryKey: [, chatInstanceId, queryIdentifier, brandIdentifier] }) => {
      return apiClient.queries.downloadHcpResults({ chatInstanceId, queryIdentifier, brandIdentifier });
    },
    meta: {
      downloader: true,
    },
    downloaderOptions: {
      onResponse: res => ({
        filename: res.filename,
        type: 'blob',
        value: res.blob,
      }),
    },
  });

};